import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

// Accessibility Context
import { AccessibilityProvider } from "./context/AccessibilityContext";
import MobileFooter from "./components/layout/MobileFooter";
import CookieBanner from "./components/shared/CookieBanner";

// Pages
import {
  HomePage,
  LeistungenPage,
  HausarztPage,
  DiagnostikPage,
  KardiologiePage,
  VorsorgePage,
  Checkup35Page,
  DMPPage,
  SchmerzPage,
  SpezialPage,
  DigitalPage,
  UeberUnsPage,
  KompassPage,
  TeamPage,
  MedicumPage,
  FAQPage,
  TerminPage,
  ImpressumPage,
  DatenschutzPage
} from "./pages";

// Unterseiten
import {
  // Hausarzt
  AkutsprechstundePage,
  AllgemeineSprechstundePage,
  HausbesuchePage,
  KrankschreibungPage,
  ImpfungenPage,
  KindervorsorgePage,
  PsychosomatikPage,
  // Diagnostik
  MRTPage,
  EKGPage,
  BelastungsEKGPage,
  UltraschallPage,
  LungenfunktionPage,
  LaborPage,
  BlutdruckPage,
  HRVPage,
  // Kardiologie
  HerzCheckPage,
  HerzUltraschallPage,
  SchlaganfallVorsorgePage,
  PraeventiveKardiologiePage,
  CardisiographiePage,
  SchrittmacherMRTPage,
  GefaessdiagnostikPage,
  // Vorsorge
  KrebsvorsorgePage,
  HautkrebsPage,
  DarmkrebsPage
} from "./pages/unterseiten";

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
};

function App() {
  return (
    <AccessibilityProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            {/* 1 - Startseite */}
            <Route path="/" element={<HomePage />} />
          
          {/* 2 - Leistungen */}
          <Route path="/leistungen" element={<LeistungenPage />} />
          
          {/* 2A - Hausärztliche Leistungen */}
          <Route path="/leistungen/hausarzt" element={<HausarztPage />} />
          <Route path="/leistungen/hausarzt/akut" element={<AkutsprechstundePage />} />
          <Route path="/leistungen/hausarzt/sprechstunde" element={<AllgemeineSprechstundePage />} />
          <Route path="/leistungen/hausarzt/hausbesuche" element={<HausbesuchePage />} />
          <Route path="/leistungen/hausarzt/krankschreibung" element={<KrankschreibungPage />} />
          <Route path="/leistungen/hausarzt/impfungen" element={<ImpfungenPage />} />
          <Route path="/leistungen/hausarzt/kindervorsorge" element={<KindervorsorgePage />} />
          <Route path="/leistungen/hausarzt/psychosomatik" element={<PsychosomatikPage />} />
          
          {/* 2B - Diagnostik-Zentrum */}
          <Route path="/leistungen/diagnostik" element={<DiagnostikPage />} />
          <Route path="/leistungen/diagnostik/mrt" element={<MRTPage />} />
          <Route path="/leistungen/diagnostik/ekg" element={<EKGPage />} />
          <Route path="/leistungen/diagnostik/belastungs-ekg" element={<BelastungsEKGPage />} />
          <Route path="/leistungen/diagnostik/ultraschall" element={<UltraschallPage />} />
          <Route path="/leistungen/diagnostik/lungenfunktion" element={<LungenfunktionPage />} />
          <Route path="/leistungen/diagnostik/labor" element={<LaborPage />} />
          <Route path="/leistungen/diagnostik/blutdruck" element={<BlutdruckPage />} />
          <Route path="/leistungen/diagnostik/hrv" element={<HRVPage />} />
          
          {/* 2C - Kardiologie */}
          <Route path="/leistungen/kardiologie" element={<KardiologiePage />} />
          <Route path="/leistungen/kardiologie/herz-check" element={<HerzCheckPage />} />
          <Route path="/leistungen/kardiologie/schrittmacher-mrt" element={<SchrittmacherMRTPage />} />
          <Route path="/leistungen/kardiologie/gefaessdiagnostik" element={<GefaessdiagnostikPage />} />
          <Route path="/leistungen/kardiologie/ultraschall" element={<HerzUltraschallPage />} />
          <Route path="/leistungen/kardiologie/schlaganfall" element={<SchlaganfallVorsorgePage />} />
          <Route path="/leistungen/kardiologie/praevention" element={<PraeventiveKardiologiePage />} />
          <Route path="/leistungen/kardiologie/cardisiographie" element={<CardisiographiePage />} />
          
          {/* 2D - Vorsorge & Prävention */}
          <Route path="/leistungen/vorsorge" element={<VorsorgePage />} />
          <Route path="/leistungen/vorsorge/checkup35" element={<Checkup35Page />} />
          <Route path="/leistungen/vorsorge/krebsvorsorge" element={<KrebsvorsorgePage />} />
          <Route path="/leistungen/vorsorge/hautkrebs" element={<HautkrebsPage />} />
          <Route path="/leistungen/vorsorge/darmkrebs" element={<DarmkrebsPage />} />
          
          {/* 2E - DMP */}
          <Route path="/leistungen/dmp" element={<DMPPage />} />
          
          {/* 2F - Schmerz & Wirbelsäule */}
          <Route path="/leistungen/schmerz" element={<SchmerzPage />} />
          
          {/* 2G - Spezial-Checks */}
          <Route path="/leistungen/spezial" element={<SpezialPage />} />
          
          {/* 2H - Digitale Services */}
          <Route path="/leistungen/digital" element={<DigitalPage />} />
          
          {/* 3 - Über uns */}
          <Route path="/ueber-uns" element={<UeberUnsPage />} />
          
          {/* 3.1 - Kompass */}
          <Route path="/ueber-uns/kompass" element={<KompassPage />} />
          
          {/* 3.2 - Team */}
          <Route path="/ueber-uns/team" element={<TeamPage />} />
          
          {/* 3.3 - Medicum */}
          <Route path="/ueber-uns/medicum" element={<MedicumPage />} />
          
          {/* 3.4 - FAQ */}
          <Route path="/ueber-uns/faq" element={<FAQPage />} />
          
          {/* 4 - Termin & Kontakt */}
          <Route path="/termin" element={<TerminPage />} />
          
          {/* 5 - Impressum */}
          <Route path="/impressum" element={<ImpressumPage />} />
          
          {/* Datenschutz */}
          <Route path="/datenschutz" element={<DatenschutzPage />} />
          
          {/* Fallback */}
          <Route path="*" element={<HomePage />} />
        </Routes>
        <MobileFooter />
        <CookieBanner />
      </BrowserRouter>
      </div>
    </AccessibilityProvider>
  );
}

export default App;
